function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", {
  id: "title-mogensen-logo"
}, "mogensen");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", {
  id: "desc-mogensen-logo"
}, "mogensen logo");

var _ref4 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "0 74.4 48.48 2.2 87.39 2.2 77.67 43.71 125.42 2.2 164.16 2.2 115.48 74.4 90.91 74.4 112.17 38.74 71.75 74.4 45.67 74.4 53.58 38.74 29.09 74.4 0 74.4"
});

var _ref5 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "409.13 74.4 457.7 2.2 483.95 2.2 490.69 43.18 519.88 2.2 547.2 2.21 498.66 74.38 469.72 74.4 463.45 34.48 436.55 74.4 409.13 74.4"
});

var _ref6 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "595.66 74.37 644.39 2.15 720.84 2.15 710.5 17.54 662.08 17.54 654.34 28.91 695.53 28.91 685.05 43.99 644.23 43.99 635.72 56.66 684.14 56.66 672.19 74.37 595.66 74.37"
});

var _ref7 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "678.31 74.37 726.89 2.15 753.14 2.15 759.88 43.12 789 2.15 816.42 2.15 767.81 74.34 738.89 74.37 732.59 34.4 705.73 74.37 678.31 74.37"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M812.94,451s24.37-9.55,24.43-9.5c7.8,16.31,36.66,14.63,42.55,4.83,1.45-2.48-.53-4.17-3.87-5-2.58-.69-25.79-6-25.79-6-12.28-5-11.65-16.46-6.9-23.58,3-4.63,13.76-14.31,37.44-16.41,37.56-3.28,45.78,14,45.78,14l-22.71,10.32c-17.81-18.76-43.12-4.12-32.92.6,7.56,3.48,20.69,4.89,26.13,7.17,14.56,6.17,12.48,17.87,7.09,24.67-3.48,4.35-21.86,18.35-45.61,18.35-37.7,0-45.62-19.35-45.62-19.35",
  transform: "translate(-300.45 -394.89)"
});

var _ref9 =
/*#__PURE__*/
React.createElement("polygon", {
  points: "326.75 74.37 375.44 2.15 451.91 2.15 441.59 17.54 393.14 17.54 385.41 28.91 426.59 28.91 416.11 43.99 375.3 43.99 366.77 56.66 415.17 56.66 403.27 74.37 326.75 74.37"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M512.83,396.37c16,.1,23.9,3.25,29.87,9.82,18.17,20-4.22,41.21-11.25,47-14.47,13.06-33,17.25-49.33,17.25-14-.14-26.64-2.34-34.95-11.14-6.44-6.84-6.7-15.78-2.11-26.3a53.39,53.39,0,0,1,16-20.2,72.52,72.52,0,0,1,25.58-12.94,92.88,92.88,0,0,1,12.76-2.59,104.53,104.53,0,0,1,13.46-.87m-5.93,13.42c-14.12,0-32.17,15.11-37.26,28.39-4.8,12.53,6.56,17.48,15.91,17.14a41.48,41.48,0,0,0,37.23-25.74c3.11-7.12,2-19.79-15.88-19.79",
  transform: "translate(-300.45 -394.89)"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M618.7,396.51c17.31,0,29.19,4,35.28,16.11l-24.2,8c-1.06-5.55-6.27-10.06-17.67-10.06-14.1,0-31.21,13.26-35.5,27.11-4.78,15.37,5.44,18.18,14.79,17.81,4.4,0,10.16-1.22,17.82-5.67l6.93-10.25H589.4L600,423.87H651.4L626.33,461c-12.32,6.86-24.33,8.83-38.1,8.83-13.09,0-26.89-1.6-35.18-10.41-6.47-6.83-6.71-15.78-2.11-26.28a54.1,54.1,0,0,1,15.9-20.22,73.89,73.89,0,0,1,25.61-13,102.57,102.57,0,0,1,12.81-2.56,100.68,100.68,0,0,1,13.44-.89",
  transform: "translate(-300.45 -394.89)"
});

var SvgMogensen = function SvgMogensen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    role: "img",
    "aria-labelledby": "title-mogensen-logo desc-mogensen-logo",
    viewBox: "0 0 816.42 75.52",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? React.createElement("title", {
    id: "title-mogensen-logo"
  }, title) : null, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMogensen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mogensen.70b8c466.svg";
export { ForwardRef as ReactComponent };